import React from 'react'
import { ModelWithForm, TriggerPipelineOnOperationExecute } from '@morningtrain/react-resources'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Pipeline } from '@morningtrain/react-helpers'
import { MountSmartviewWithModelOnPipe } from '@morningtrain/react-smartviews'
import { OnboardingTemplateSmartview } from 'widgets/smartviews/onboarding/OnboardingTemplateSmartview'
import * as Icons from 'ui/icons'
import { Fieldset } from 'layouts'
import * as Fields from 'support/fields'
import { ResourceSelector } from 'support/fields'
import { Repeater } from '@morningtrain/react-fields-repeater-field'
import { Link } from '@morningtrain/react-navigation'
import ModelValueTitle from 'widgets/ModelValueTitle'
import { Can } from '@morningtrain/react-auth'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'
import ConfirmFormChanges from '../../../support/pipelines/ConfirmFormChanges'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'

export default function OnboardingTemplate () {
  return (
    <AdminPageWithSmartview>
      <Translator namespace="onboarding">
        <UI.CardGroup>

          <ModelWithForm resourceName="onboarding.onboarding_checklist_templates">
            <ConfirmFormChanges/>
            <RedirectToEditOnCreatePipeline routeName={'app.onboarding.template'}/>
            <Pipeline>
              <TriggerPipelineOnOperationExecute/>
              <MountSmartviewWithModelOnPipe smartview={<OnboardingTemplateSmartview/>}/>
            </Pipeline>

            <UI.PageHeader title={<ModelValueTitle name="name"/>}>
              <UI.ButtonWrap className="my-8">
                <Link route="app.onboarding.templates">
                  <UI.Button>
                    <Icons.ArrowLeft className="mr-2"/>
                    <span><Translation name="onboarding.actions.back_to_overview"/></span>
                  </UI.Button>
                </Link>
                <UI.SubmitButton>
                  <Translation name="generic.save"/>
                </UI.SubmitButton>
              </UI.ButtonWrap>
            </UI.PageHeader>

            <UI.CardGroup>

              <UI.Card>
                <Fieldset cols={2}>
                  <Fields.Input name='name_da' label={<Translation name='fields.name_translations.da.label'/>}/>
                  <Fields.Input name='name_en' label={<Translation name='fields.name_translations.en.label'/>}/>
                  <ResourceSelector
                    name='employment_type_ids'
                    optionsKey='name'
                    resourceName='employments.employment_type'
                    label={<Translation name='fields.employee_type.label'/>}
                    multiple
                  />
                  <Can permission='api.files.tags.index'>
                    <Fields.ResourceSelector
                      name='file_tag_ids'
                      optionsKey='name'
                      multiple
                      placeholder='-'
                      resourceName='files.tags'
                      label={<Translation name='fields.file_tags.label'/>}
                      operationName='index'
                    />
                  </Can>
                  <Fields.Checkbox
                    label={<Translation name='fields.active.label'/>}
                    name='active'
                  />
                </Fieldset>
              </UI.Card>

              <Repeater
                name='fields'
                buttonClass='btn btn-sq btn-primary'
                label={<Translation name='fields.checklist_fields.label'/>}
                addLabel={<Icons.Plus className='w-3 h-3'/>}
                removeLabel={<Icons.Trash className='w-4 h-4'/>}
              >
                <UI.Card>
                  <Fieldset cols={2}>
                    <Fields.Input
                      name='label_da'
                      label={<Translation name='fields.title_translations.da.label'/>}
                    />
                    <Fields.Input
                      name='label_en'
                      label={<Translation name='fields.title_translations.en.label'/>}
                    />
                    <Fields.TextArea
                      name='description_da'
                      label={<Translation name='fields.description_translations.da.label'/>}
                      class=''
                    />
                    <Fields.TextArea
                      name='description_en'
                      label={<Translation name='fields.description_translations.en.label'/>}
                    />
                  </Fieldset>
                </UI.Card>
              </Repeater>

              <UI.ButtonWrap>
                <UI.SubmitButton>
                  <Translation name="generic.save"/>
                </UI.SubmitButton>
              </UI.ButtonWrap>

            </UI.CardGroup>
          </ModelWithForm>

        </UI.CardGroup>
      </Translator>
    </AdminPageWithSmartview>
  )
}
